import { render, staticRenderFns } from "./modalBloqueioHorarios.vue?vue&type=template&id=7ff55b92&"
import script from "./modalBloqueioHorarios.vue?vue&type=script&lang=js&"
export * from "./modalBloqueioHorarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports